export const SITE_NAME = 'Hotel Boutique Nueva Valladolid'

export const BOOKING_ROUTE = '/booking'
export const ROOMS_ROUTE = '/rooms'

export const NAV_LINKS: Array<{ href: string; labelKey: string }> = [
  { href: '/', labelKey: 'nav.home' },
  { href: '/about', labelKey: 'nav.about' },
  { href: '/rooms', labelKey: 'nav.rooms' },
  { href: '/explore', labelKey: 'nav.explore' },
  { href: '/contact', labelKey: 'nav.contact' },
]

export const CONTACT = {
  phone: '+504 3264 9600',
  whatsapp: '+504 3264 9600',
  email: 'reserva@hbnuevavalladolid.com',
  address: 'Barrio Abajo, Comayagua, 12101, Honduras',
  googleMapsUrl:
    'https://www.google.com/maps/search/Hotel+Boutique+Nueva+Valladolid+Comayagua+Honduras',
  googleMapsEmbed:
    'https://maps.google.com/maps?q=Hotel+Boutique+Nueva+Valladolid%2C+Comayagua%2C+Honduras&t=&z=16&ie=UTF8&iwloc=&output=embed',
}

export const SOCIAL = {
  facebook: '',
  instagram: 'https://www.instagram.com/hotelboutiquenuevavalladolid',
}

export const RATINGS = {
  booking: { label: '9.0/10', score: 9.0 },
  google: { label: '4.7/5', score: 4.7 },
}
